import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Slider from "react-slick";
import NotFound from "../shared/NotFound";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FaArrowRight, FaRegUser, FaSearchengin } from "react-icons/fa6";
import { useEffect, useState } from "react";
import axios from "axios";
import helper from "../../utils/helper";

export default function Content() {
    const [data, setData] = useState<any[]>([]);
    const [pagination, setPagination] = useState<any>({});
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [activeCategory, setActiveCategory] = useState<string>('');
    const [category, setCategory] = useState<string>('');

    const getSearchFromUrl = new URLSearchParams(window.location.search).get('search');
    const getCategoryFromUrl = new URLSearchParams(window.location.search).get('category');

    const getData = async (page: number = 1, search: string = '', category: string = '') => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/product?page=${page}&search=${search}&category=${category}`);
            if (response && response.data && response.data.data) {
                setData(response.data.data.data);
                setPagination(response.data.data);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    };

    useEffect(() => {
        if (searchQuery) {
            setActiveCategory("");
        }

        if (getSearchFromUrl) {
            setSearchQuery(getSearchFromUrl);
        }

        if (getCategoryFromUrl) {
            setCategory(getCategoryFromUrl);
            setActiveCategory(getCategoryFromUrl);
        }

        getData(currentPage, getSearchFromUrl || searchQuery, getCategoryFromUrl || category);
    }, [currentPage, getCategoryFromUrl, getSearchFromUrl]);

    const handleCategoryClick = (category: string) => {
        if (category === '') {
            setSearchQuery('');
            setCategory('');
            setActiveCategory('');
            window.history.pushState({}, '', '/produk');
        } else {
            setActiveCategory(category);
            setCategory(category);
            setSearchQuery('');
            setCurrentPage(1);
            window.history.pushState({}, '', `?category=${category}`);
        }
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const query = e.target.value;
        setCategory('');
        setSearchQuery(query);
        setCurrentPage(1);
        if (query) {
            window.history.pushState({}, '', `?search=${query}`);
        } else {
            window.history.pushState({}, '', window.location.pathname);
        }
    };

    const categories = [
        { label: 'All', value: '' },
        { label: 'Kredit', value: 'kredit' },
        { label: 'Deposito', value: 'deposito' },
        { label: 'Tabungan', value: 'tabungan' },
    ];

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    return (
        <div className="max-w-screen-2xl mx-auto pt-16 pb-60 p-5 md:p-5 lg:p-16">
            <div className="flex flex-col sm:flex-row justify-between text-sm mt-5">
                <div className="flex space-x-5 mb-4 sm:mb-0 overflow-x-auto md:overflow-visible scrollbar whitespace-nowrap hide-scrollbar">
                    {categories.map((category) => (
                        <button
                            key={category.value}
                            className={`py-1 px-3 rounded ${activeCategory === category.value ? 'bg-bprDarkBlue text-white' : 'bg-white text-bprDarkBlue border border-bprDarkBlue'}`}
                            onClick={() => handleCategoryClick(category.value)}
                        >
                            {category.label}
                        </button>
                    ))}
                </div>

                <div className="flex items-center justify-start w-full sm:items-center sm:justify-end">
                    <div className="relative w-full sm:w-auto">
                        <input
                            type="text"
                            placeholder="Search..."
                            className={`py-2 pl-10 pr-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-bprDarkBlue text-sm w-full ${data.length === 0 ? 'disabled:opacity-50 cursor-not-allowed' : 'sm:w-60'}`}
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />

                        <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
                            <FaSearchengin className="text-sm" />
                        </span>
                    </div>
                </div>
            </div>

            <motion.div
                initial={{ opacity: 0, y: -100 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1.2 }}
                className="mt-14"
            >
                <div className="block md:hidden">
                    <Slider {...settings}>
                        {data.length === 0 ? (
                            <NotFound />
                        ) : (
                            data.map((product) => (
                                <div key={product.id} className="px-2">
                                    <ProductCard product={product} />
                                </div>
                            ))
                        )}
                    </Slider>
                </div>

                {data.length === 0 ? (
                    <div className="hidden md:block">
                        <NotFound />
                    </div>
                ) : (
                    <div className="hidden md:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 gap-y-10">
                        {data.map((product) => (
                            <div key={product.id} className="px-2">
                                <ProductCard product={product} />
                            </div>
                        ))}
                    </div>
                )}
            </motion.div>

            <div className="mt-10 ">
                {pagination.total > 0 && (
                    <nav aria-label="Page navigation example" className="flex justify-end">
                        <ul className="inline-flex -space-x-px text-base h-10">
                            <li>
                                <button
                                    onClick={() => handlePageChange(pagination.current_page - 1)}
                                    disabled={!pagination.prev_page_url}
                                    className="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700"
                                >
                                    &laquo; Previous
                                </button>
                            </li>
                            {pagination.links &&
                                pagination.links.map((link: any, index: number) =>
                                    link.url && link.label !== '&laquo; Previous' && link.label !== 'Next &raquo;' ? (
                                        <li key={index}>
                                            <button
                                                onClick={() =>
                                                    handlePageChange(Number(new URL(link.url).searchParams.get('page')))
                                                }
                                                className={`flex items-center justify-center px-4 h-10 leading-tight ${link.active ? 'text-blue-600 bg-blue-50' : 'text-gray-500 bg-white'
                                                    } border border-gray-300 hover:bg-gray-100 hover:text-gray-700`}
                                            >
                                                {link.label}
                                            </button>
                                        </li>
                                    ) : null
                                )}
                            <li>
                                <button
                                    onClick={() => handlePageChange(pagination.current_page + 1)}
                                    disabled={!pagination.next_page_url}
                                    className="flex items-center justify-center px-4 h-10 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700"
                                >
                                    Next &raquo;
                                </button>
                            </li>
                        </ul>
                    </nav>
                )}
            </div>
        </div>
    );
}

function ProductCard({ product, handleClickSaveId }: any) {
    return (
        <div className="w-full rounded-br-[5.5rem] overflow-hidden border flex flex-col">
            <div className="w-full h-[200px]">
                <LazyLoadImage
                    src={`${process.env.REACT_APP_API_ENDPOINT}/product/getimg/${product.img_product}`}
                    alt="offers"
                    effect="blur"
                    className="w-full h-full object-cover object-top "
                    wrapperProps={{
                        style: { transitionDelay: '1s' },
                    }}
                />
            </div>
            <div className="flex-grow flex flex-col justify-between p-3">
                <div>
                    <div className="flex flex-row justify-between items-center text-[#B9B9B9] mb-2">
                        <div className="flex items-center space-x-2">
                            <span className="text-sm pt-1">{product.category}</span>
                        </div>
                        <div className="flex justify-end">
                            <span className="text-sm pt-1 ml-auto">     {new Intl.DateTimeFormat('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(product.created_at))}</span>
                        </div>
                    </div>
                    <div className="font-poppinsBold text-sm mt-2 mb-4" dangerouslySetInnerHTML={{ __html: product.title }} />
                    <p className="text-textPrimary mt-3" dangerouslySetInnerHTML={{ __html: helper.handleDescription(product.description, 50) }} />
                    <div className="relative mt-28">
                        <Link to={`/detail-produk/${product.slug_title}`} className="absolute right-10 bottom-3 rounded-full border border-bprDarkBlue p-3 group hover:bg-bprDarkBlue transition-all duration-300 ease-in-out">
                            <FaArrowRight className="text-xl text-bprDarkBlue group-hover:text-white transition-colors duration-300 ease-in-out" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
